// Import React
import React from "react";

// Import MUI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled, useTheme } from "@mui/material/styles";
import logo from "../../src/assets/images/Servall-Logo-1.png";

// Import Settings Context
import { useSettings } from "src/@core/hooks/useSettings";

const RightWrapper = styled(Box)(({ theme }) => ({
  margin: "auto",
  [theme.breakpoints.up("md")]: {
    maxWidth: 550,
  },
}));

const AuthLayout = ({ children }) => {
  const theme = useTheme();
  const { settings } = useSettings();

  const { skin } = settings;
  const hidden = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
      <Grid container className="content-right" spacing={4}>
        <Grid size={12}>
          <Box className="content-center">
            <RightWrapper
              sx={
                skin === "bordered" && !hidden
                  ? { borderLeft: `1px solid ${theme.palette.divider}` }
                  : {}
              }
            >
              {hidden && (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  marginBottom="2.5rem"
                  marginTop="2.5rem"
                >
                  {/* <Logo /> */}
                  <img src={logo} alt="logo" />
                </Box>
              )}

              {children}
            </RightWrapper>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default AuthLayout;
